// import { Observable } from 'rxjs/Observable';
import { Observable } from 'rxjs/Rx';
import 'rxjs/add/operator/catch';
import 'rxjs/add/operator/do';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';

import {HttpEvent, HttpResponse, HttpInterceptor, HttpHandler, HttpRequest,
   HTTP_INTERCEPTORS} from '@angular/common/http';
import { MQService } from './mq.service'
import { ConfigService } from './config.service'
import { OAuthService } from './oauth2.service'

@Injectable({
  providedIn: 'root'
})
export class HttpWithAuth implements HttpInterceptor {
  constructor(protected mq: MQService, private config: ConfigService, private router: Router) {
  }

  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    let authReq = req;
    if (req.headers.get('no-options-req')) {
        authReq = req.clone({headers: req.headers.delete('no-options-req')});
      //authReq = req0.clone({withCredentials: true});
    }else if (req.headers.get('no-options-req-with-cred')){
        const req0 = req.clone({ headers: req.headers.delete('no-options-req-with-cred').set('Access-Control-Allow-Origin', '*') });
        authReq = req0.clone({withCredentials: true});
    } else {
      const req0 = req.clone({headers: req.headers.set('Authorization', this.retrieveAuthToken())});
      authReq = req0.clone({headers: req0.headers.set('Access-Control-Allow-Origin', '*')});

      this.mq.notify('loader.show', { text: 'Requesting' });
    }
    return next.handle(authReq)
      .do((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {
          this.mq.notify('loader.close', { text: '' });
        }
      }, (err: any) => {
        this.mq.notify('loader.alert', { html: err.error, text: ''});
      })
      .catch(err => {
        console.log('Http error', err);
        if (err.status === 401) {
          // try to refresh token
          this.router.navigate(['/login']);
          this.mq.notify('loader.close', { text: '' });
        }
        this.mq.notify('loader.debug', { html: err.error, text: err.message });
        return Observable.throw(err);
      });
  }

  private retrieveAuthToken(): string {
    const service: OAuthService = <OAuthService> this.config.get('oauth2service');
    if (service) {
      return service.getAuthorization();
    }
    return '';
  }
}

export const HTTPCLIENT_AUTH_PLUGIN = {
  provide: HTTP_INTERCEPTORS,
  useClass: HttpWithAuth,
  multi: true,
}
